// extracted by mini-css-extract-plugin
export default {"recommended-container":"RecommendedTextbooks_recommended-container__GMxXu","imgs":"RecommendedTextbooks_imgs__vHFwV"};